(function () {
    'use strict';

    function eventIndex($window) {
        var vm = this;

        function filter(e, campus) {
            if (e) {
                e.preventDefault();
            }

            vm.campusFilter = campus !== 'All' ? campus : '';
        }

        const getEventIcs = id => 
            $window.open(`/webapi/icsservice/getevent?id=${id}&eventType=event`, '_self', '');        

        angular.extend(vm, {
            campusFilter: '',

            getEventIcs: getEventIcs,
            filter: filter
        });

    }

    angular.module('Uscapp').controller('eventIndexController', ['$window', eventIndex]);
}());